import "./index.css"
import React from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import PolicyPage from "./Privicy";
import NotFound from "./NotFound";
import SongSubmission from "./Event/SongSubmission"
import GlaciaLogo from "./assets/GLACIA LOGO.jpg"
import TitleLogo from "./assets/TitleLogo.png"
import Android from "./assets/and.png"
import iOS from "./assets/ios.png"

class Title extends React.Component{
    render(){
        return(
            <div className='Title'>
               <img className='TitleLogo' src={TitleLogo} alt=""/>
               <img className="GlaciaLogo" src={GlaciaLogo} alt=""/>
            </div>
        )
    }
}
//跳转页面
class PageContent extends React.Component{
    render(){
        return(
            <div className="IndexPage">
                <div className="iOS" onClick={()=>window.open(new URL("https://apps.apple.com/us/app/轴音旋律-anxiens/id6448164217"))} style={{margin:"1em 0"}}><img className="Button" src={iOS} alt=""/></div>
                <div className="Android" onClick={()=>window.open(new URL("https://play.google.com/store/apps/details?id=com.GlaciaStudio.AnXiens"))}><img className="Button" src={Android} alt=""/></div>
                <p>
                   <Link className="Link" to={{pathname:"/Privicy/privicy"}}>Privicy Policy</Link> 
                </p>
                <p>
                   <Link className="Link" to={{pathname:"/Privicy/tremofuse"}}>Term of Use</Link> 
                </p>
                <p>
                   <Link className="Link" to={{pathname:"/Privicy/datasecu"}}>Data Security</Link> 
                </p>
                <p>
                    <Link className="Link" to={{pathname:"/Privicy/accountcancellation"}}>Acount Manage</Link> 
                </p>
                <p>
                    <Link className="Link" onClick={()=>window.open(new URL("https://beian.miit.gov.cn/"))}>
                    陕ICP备2023011835号
                    </Link>
                </p>
                
            </div>
        )
    }
}
//页面主组件
class App extends React.Component{
    componentDidMount(){
        document.title = 'AnXiens'
    }
  render(){
    const offsetWidth = document.querySelector("body").offsetWidth
    return (
        <div className="MainPage" style={offsetWidth<1080?{backgroundSize:"cover"}:{backgroundSize:"contain"}}>
            <Title/>
            <PageContent/>
        </div>
      )
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<BrowserRouter>
                <Routes>
                    <Route path="/" element={<App />}></Route>
                    <Route path="/Privicy/:type" element={<PolicyPage />} Component={PolicyPage}></Route>
                    <Route path="/event/songsubmission2025/" element={<SongSubmission />}></Route>
                    <Route path="*" element={<NotFound />}></Route>
                </Routes>
        </BrowserRouter>)

export default root;